import React, { Component } from 'react';
import Canvas from '../components/canvas';

class create extends Component {
    render() {
        return (
            <div class="create">
                <Canvas />
            </div>
        );
    }
}

export default create;